import * as Yup from "yup";
import { StringValidation } from "../PlanSchema";

export const PerspectiveSchema = Yup.object().shape({
  name: StringValidation.label("Perspective name"),
});
